module.exports = __webpack_public_path__ + "static/media/Bodkin of Wundor.344cded8.mp3";